export const fetchTempLayer = async (datetime) => {
  // Skip API call if disabled
  if (!window.AIRMAP_CONFIG?.apiEnabled) {
    return null;
  }

  try {
    const response = await fetch(
      "/wp-json/aprilaire/v1/airmap/proxy",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          meteomaticsUrl: `https://api.meteomatics.com/${datetime}/t_2m:C/75,-140_-25,-30:0.2,0.2/png`,
        }),
      }
    );

    const data = await response.blob();
    return data;
  } catch (error) {
    console.error("Error fetching AQIData", error);
    return null;
  }
};

export const fetchMeteomaticsAQIData = async (datetime) => {
  // Skip API call if disabled
  if (!window.AIRMAP_CONFIG?.apiEnabled) {
    return null;
  }

  try {
    const response = await fetch(
      "/wp-json/aprilaire/v1/airmap/proxy",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          meteomaticsUrl: `https://api.meteomatics.com/${datetime}/air_quality_pm2p5:idx/75,-140_-25,-30:0.5,0.5/json`,
        }),
      }
    );

    const data = await response.json();

    return data?.data?.data?.[0]?.coordinates;
  } catch (error) {
    console.error("Error fetching AQIData", error);
    return null;
  }
};
